import BigPanel from "../../components/BigPanel/BigPanel";

function Impressum() {
  return (
    <BigPanel title="Impressum">
      <p><strong>Fit-to-Clean Gebäudereinigung Christian Schweiger e.K.</strong></p>
      <p>Seniweg 2, 82538 Geretsried</p>
      <p>Mobil: 0176 – 8430 5728</p>
      <p>Festnetz: 08171 – 6971</p>
      <p>Fax: 08171 – 345340</p>
      <p>Email: info@fit-to-clean.de</p>
      <p>Web: www.fit-to-clean.de</p>
      <p>Geschäftsführer: Christian Schweiger</p>
      <p>HRB-Nr.: 113048, Amtsgericht München</p>
      <p>USt-IdNr.: DE 276585640</p>
    </BigPanel>
  );
}

export default Impressum;
